import { AgencyAdminStoreError } from "../../enums/store-messages/admin";
import { Agency, Jog } from "../../reducers/states/agency";
import { types } from "../types";

// For Agencies, the API/StepFunction handles setting modified and created information.
export type createAgencyPayload = Omit<Agency, "id" | "lastModifiedBy" | "lastModifiedDate" | "createdBy" | "createdDate">
// For updates, the existing "created" fields are required/maintained.
export type updateAgencyPayload = Omit<Agency, "lastModifiedBy">

// CREATE
export const createAgencyRequest = (agency: Agency) => ({
  type: types.CREATE_AGENCY,
  payload: {
    ...agency,
  },
});

// todo: jcavner: eventually add new agency object or new agency ID to payload, so agency list could be updated in state instead of with a new request for all Agencies
export const createAgencySuccess = () => ({
  type: types.CREATE_AGENCY_SUCCESS
});

export const createAgencyFailure = () => ({
  type: types.CREATE_AGENCY_FAILURE,
  payload: { message: AgencyAdminStoreError.CREATE_AGENCY_ERROR },
});

// GET
export const getAgenciesRequest = () => ({
  type: types.GET_AGENCIES
});

export const getAgenciesSuccess = (agencies: Agency[], jogs: Jog[]) => ({
  type: types.GET_AGENCIES_SUCCESS,
  payload: { agencies, jogs },
});

export const getAgenciesFailure = (message: string) => ({
  type: types.GET_AGENCIES_FAILURE,
  payload: { message },
});

// UPDATE
export const updateAgencyRequest = (agency: Agency) => ({
  type: types.UPDATE_AGENCY,
  payload: {
    ...agency,
  },
});

// todo: jcavner: eventually add updated agency object to payload
export const updateAgencySuccess = () => ({
  type: types.UPDATE_AGENCY_SUCCESS,
});

export const updateAgencyFailure = () => ({
  type: types.UPDATE_AGENCY_FAILURE,
  payload: { message: AgencyAdminStoreError.UPDATE_AGENCY_ERROR },
});